import DashboardIcon from '@mui/icons-material/Dashboard';
import VideocamIcon from '@mui/icons-material/Videocam';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PeopleIcon from '@mui/icons-material/People';
import GroupIcon from '@mui/icons-material/Group';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import SensorsIcon from '@mui/icons-material/Sensors';
import LayersIcon from '@mui/icons-material/Layers';
import TimelineIcon from '@mui/icons-material/Timeline';
import AssessmentIcon from '@mui/icons-material/Assessment';

export const getSidebarItemsByRole = (role) => {
  switch (role) {
    case 'admin':
      return [
        { label: 'Dashboard', path: '/dashboard', icon: <DashboardIcon /> },
        { label: 'Clients', path: '/clients', icon: <GroupIcon /> },
        { label: 'Staff', path: '/staff', icon: <PeopleIcon /> },
        { label: 'Monitoring', path: '/monitoring', icon: <SensorsIcon /> },
        { label: 'Fall Events', path: '/fall-events', icon: <WarningAmberIcon /> },
        { label: 'Fall Reports', path: '/fall-reports', icon: <AssessmentIcon /> },
        { label: 'Contact Inbox', path: '/contact-submissions', icon: <MailOutlineIcon /> },
        { label: 'Cameras', path: '/cameras', icon: <VideocamIcon /> },
        { label: 'Invoices', path: '/invoices', icon: <ReceiptIcon /> },
        { label: 'Subscriptions', path: '/subscriptions', icon: <LayersIcon /> },
        { label: 'Payments', path: '/payments', icon: <PaymentIcon /> },
        { label: 'User Activity', path: '/user-activity', icon: <TimelineIcon /> },
        { label: 'Profile', path: '/profile', icon: <PeopleIcon /> },
      ];
    case 'client':
      return [
        { label: 'Dashboard', path: '/client-dashboard', icon: <DashboardIcon /> },
        { label: 'Fall History', path: '/fall-logs', icon: <WarningAmberIcon /> },
        { label: 'Invoices', path: '/client-invoices', icon: <ReceiptIcon /> },
        { label: 'Contact Support', path: '/contact', icon: <MailOutlineIcon /> },
        { label: 'Profile', path: '/client-profile', icon: <PeopleIcon /> },
      ];
    case 'nurse':
    case 'carer':
      return [
        { label: 'Dashboard', path: `/${role}-dashboard`, icon: <DashboardIcon /> },
        { label: 'Live Monitoring', path: '/dashboard', icon: <VideocamIcon /> },
        { label: 'Fall Events', path: '/fall-events', icon: <WarningAmberIcon /> },
      ];
    default:
      return [];
  }
};
